import { useRouter } from 'next/router';
import { IListing } from 'src/interface';
import ListingsApis from 'src/api/listings';
import { useNotifier } from 'src/contexts/notification/notification.context';
import { useCallback, useEffect, useState } from 'react';

const useGetShortLink = (listing: IListing) => {
  const { errorAlert } = useNotifier();
  const router = useRouter();
  const { asPath } = router;

  const [shortLink, setShortLink] = useState('');

  const getShortLink = useCallback(async () => {
    try {
      const model = {
        dynamicLinkInfo: {
          domainUriPrefix: 'https://link.rentable.pk',
          // link: `${origin}${pathname}`,
          link: `https://rentable.pk${asPath}`,
          socialMetaTagInfo: {
            socialTitle: listing.title,
            socialDescription: listing.short_description,
            socialImageLink: listing.images[0],
          },
          androidInfo: {
            androidPackageName: 'pk.com.rentable',
          },
          iosInfo: {
            iosBundleId: 'com.rentable.rentablepakistan',
            iosFallbackLink: null,
            iosIpadBundleId: 'com.rentable.rentablepakistan',
            iosIpadFallbackLink: null,
            iosAppStoreId: '1508744193',
          },
          navigationInfo: {
            enableForcedRedirect: true,
          },
        },
      };
      const result = await ListingsApis.fetchListingDeepLink(JSON.stringify(model));
      if (result.status === 200) {
        return result.data.shortLink;
      }
      return null;
      errorAlert('Something went wrong with Short link');
    } catch (error) {
      console.log(error);
      return null;
    }
  }, [errorAlert, listing, asPath]);

  useEffect(() => {
    if (!shortLink) {
      (async () => {
        const link: string | null = await getShortLink();
        if (link) {
          setShortLink(link);
        }
      })();
    }
  }, [shortLink, getShortLink]);

  return { shortLink };
};

export default useGetShortLink;
